import React from "react"
import { Table, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableBody } from "material-ui"
import { IRecord, IPunchAudit } from "../../models"
import strings from "../../localization/strings"
import AcceptSuspensePunchResultDetailCol from "./AcceptSuspensePunchResultDetailCol"
import * as timeHelper from "../../helpers/timeHelper"
import moment from "moment"

interface IProps {
	selectedRecords: IRecord[]
	acceptResult: { string: IPunchAudit }
}

const AcceptSuspensePunchResultTable: React.SFC<IProps> = (props: IProps) => {
	return (
		<Table selectable={false}>
			<TableHeader
				displaySelectAll={false}
				adjustForCheckbox={false}
				enableSelectAll={false}
			>
				<TableRow style={{ height: 25 }}>
					<TableHeaderColumn style={{ height: 25 }}>{strings.Status}</TableHeaderColumn>
					<TableHeaderColumn style={{ height: 25 }}>{strings.Employee}</TableHeaderColumn>
					<TableHeaderColumn style={{ height: 25 }}>{strings.Date}</TableHeaderColumn>
					<TableHeaderColumn style={{ height: 25 }}>{strings.Time}</TableHeaderColumn>
					<TableHeaderColumn style={{ padding: 0, height: 25, width: 50, textAlign: "center" }}>{strings.Details}</TableHeaderColumn>
				</TableRow>
			</TableHeader>
			<TableBody displayRowCheckbox={false}>
				{props.selectedRecords.map((record, index) => {
					const notAcceptAudit: IPunchAudit = props.acceptResult[record.Punch.Id]
					const colStyle = { height: 30, color: notAcceptAudit && "red" }
					const punchDateTimeLocal = moment(timeHelper.keepConvertUTCToLocal(record.Punch.DateTimeLocal))
					return (
						<TableRow key={index} style={{ height: 30, borderBottom: "none" }}>
							<TableRowColumn style={colStyle}>
								{`${index + 1}) ${notAcceptAudit ? strings.NotAccepted : strings.Accepted}`}
							</TableRowColumn>
							<TableRowColumn style={colStyle}>
								{record.UserFirstName} {record.UserLastName}
							</TableRowColumn>
							<TableRowColumn style={colStyle}>
								{punchDateTimeLocal.format("MMM. DD, YYYY")}
							</TableRowColumn>
							<TableRowColumn style={colStyle}>
								{punchDateTimeLocal.format("h:mm A")}
							</TableRowColumn>
							<TableRowColumn style={{ padding: 0, height: 30, width: 50, textAlign: "center" }}>
								<AcceptSuspensePunchResultDetailCol
									auditNote={notAcceptAudit ? notAcceptAudit.Note : null}
									orderKey={String(index)}
								/>
							</TableRowColumn>
						</TableRow>
					)
				})}
			</TableBody>
		</Table>
	)
}

export default AcceptSuspensePunchResultTable